const externalLink = () => {
  const acatoVariables = acato_variables || {}; // Passed by wp_localize_script.
  const links = document.querySelectorAll( 'main a' );
  const currentDomain = window.location.hostname;
  const excludedDomains = ['app-eu.readspeaker.com'];

  function externalLinkSvg() {
    const svg = document.createElementNS( 'http://www.w3.org/2000/svg', 'svg' );
    svg.setAttribute( 'viewBox', '0 0 24 24' );
    svg.setAttribute( 'fill', 'none' );

    const title = document.createElementNS( 'http://www.w3.org/2000/svg', 'title' );
    title.textContent = acatoVariables.open_in_new_window || 'Open in new window';
    svg.appendChild( title );

    const path = document.createElementNS( 'http://www.w3.org/2000/svg', 'path' );
    path.setAttribute( 'd', 'M13.2166 12.2207L13.2167 12.2207L13.2191 12.2182L19.5875 5.84986V10.25C19.5875 10.4257 19.6573 10.5942 19.7815 10.7185C19.9058 10.8427 20.0743 10.9125 20.25 10.9125C20.4257 10.9125 20.5942 10.8427 20.7185 10.7185C20.8427 10.5942 20.9125 10.4257 20.9125 10.25V4.25C20.9125 4.07429 20.8427 3.90578 20.7185 3.78154C20.5942 3.6573 20.4257 3.5875 20.25 3.5875H14.25C14.0743 3.5875 13.9058 3.6573 13.7815 3.78154C13.6573 3.90578 13.5875 4.07429 13.5875 4.25C13.5875 4.42571 13.6573 4.59422 13.7815 4.71846C13.9058 4.8427 14.0743 4.9125 14.25 4.9125H18.6502L12.2827 11.2818L12.2827 11.2818L12.2803 11.2843C12.1633 11.4099 12.0995 11.576 12.1026 11.7477C12.1056 11.9193 12.1751 12.083 12.2965 12.2044C12.4179 12.3258 12.5816 12.3953 12.7533 12.3984C12.9249 12.4014 13.091 12.3377 13.2166 12.2207ZM17.25 12.5875C17.0743 12.5875 16.9058 12.6573 16.7815 12.7815C16.6573 12.9058 16.5875 13.0743 16.5875 13.25V20C16.5875 20.0232 16.5783 20.0455 16.5619 20.0619C16.5455 20.0783 16.5232 20.0875 16.5 20.0875H4.5C4.47679 20.0875 4.45454 20.0783 4.43813 20.0619C4.42172 20.0455 4.4125 20.0232 4.4125 20V8C4.4125 7.97679 4.42172 7.95454 4.43813 7.93813C4.45454 7.92172 4.47679 7.9125 4.5 7.9125H11.25C11.4257 7.9125 11.5942 7.8427 11.7185 7.71846C11.8427 7.59422 11.9125 7.42571 11.9125 7.25C11.9125 7.07429 11.8427 6.90578 11.7185 6.78154C11.5942 6.6573 11.4257 6.5875 11.25 6.5875H4.5C4.12538 6.5875 3.76611 6.73632 3.50121 7.00121C3.23632 7.26611 3.0875 7.62538 3.0875 8V20C3.0875 20.3746 3.23632 20.7339 3.50121 20.9988C3.76611 21.2637 4.12538 21.4125 4.5 21.4125H16.5C16.8746 21.4125 17.2339 21.2637 17.4988 20.9988C17.7637 20.7339 17.9125 20.3746 17.9125 20V13.25C17.9125 13.0743 17.8427 12.9058 17.7185 12.7815C17.5942 12.6573 17.4257 12.5875 17.25 12.5875Z' );
    path.setAttribute( 'fill', 'currentColor' );
    path.setAttribute( 'stroke', 'currentColor' );
    path.setAttribute( 'stroke-width', '0.2' );
    svg.appendChild( path );
    return svg;
  }

  links.forEach( link => {
    const linkDomain = new URL( link.href ).hostname;

    if (linkDomain && linkDomain !== currentDomain && (!excludedDomains.includes( linkDomain ))) {
      const card = link.closest( '.card' );
      if (card) {
        card.classList.add( 'external-link-card' );
        const arrowRight = card.querySelector( '.card__link-arrow svg' );
        if (arrowRight) {
          const externalLink = externalLinkSvg();
          externalLink.setAttribute( 'width', '24' );
          externalLink.setAttribute( 'height', '24' );
          arrowRight.before( externalLink );
          arrowRight.remove();
        }
      } else if (link.classList.contains( 'hero__cta' )) {
        const arrowRight = link.querySelector( ' svg' );
        if (arrowRight) {
          const externalLink = externalLinkSvg();
          externalLink.setAttribute( 'width', '24' );
          externalLink.setAttribute( 'height', '24' );
          arrowRight.before( externalLink );
          arrowRight.remove();
        }
      } else {
        const span = document.createElement( 'span' );
        while (link.firstChild) {
          span.appendChild( link.firstChild );
        }
        link.appendChild( span );
        link.classList.add( 'external-link' );
        const svg = externalLinkSvg();
        link.appendChild( svg );
      }
    }
  } );
};

export default externalLink;
